import { createSelector } from 'reselect';
import { createDisplayLayoutNameSelector } from './display-layout-name-selector.esm.js';

var getOtherLayoutNames = function getOtherLayoutNames(displayLayouts, layoutName) {
  return displayLayouts.map(function (l) {
    return l.label || '';
  }).filter(function (l) {
    return (l === null || l === void 0 ? void 0 : l.toLowerCase()) !== (layoutName === null || layoutName === void 0 ? void 0 : layoutName.toLowerCase());
  });
};
var createOtherLayoutNamesSelector = function createOtherLayoutNamesSelector() {
  var displayLayoutNameSelector = createDisplayLayoutNameSelector();
  return createSelector(function (props) {
    return props.displayLayouts;
  }, displayLayoutNameSelector, getOtherLayoutNames);
};

export { createOtherLayoutNamesSelector, getOtherLayoutNames };
//# sourceMappingURL=other-layout-names-selector.esm.js.map
